module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    attrs: {
      "src": _vm.src,
      "id": "embedded-app"
    }
  }, [_c('p', [_vm._v("Your browser does not support iframes. Please enable iframes or try using a modern browser")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d9dc865!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmbeddedApp.vue
// module id = 246
// module chunks = 2